import React from 'react';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import styled from 'styled-components';
import { toggleTicketFavorite } from 'Actions/ticketActions';
import { connect } from 'react-redux';

const FavButtonWrapper = styled.div`
  color: #ffca28;
  cursor: pointer;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 0;
`;

const FavButton = props => (
  <FavButtonWrapper
  // onClick={() => toggleTicketFavorite(props.projectId, props.ticketId)}
  >
    {props.favorited ? <Star /> : <StarBorder />}
  </FavButtonWrapper>
);

const mapDispatchToProps = dispatch => ({
  toggleTicketFavorite: (projectId, ticketId) => {
    dispatch(toggleTicketFavorite(projectId, ticketId));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(FavButton);
